import { translate } from "game/translate";
import { ActionConfig } from "./types";

export function getQuestLabel(key: string, targetProgress: number, ...params: string[]) {
    let str = translate(key);

    const phraseKey = extractKey(str);

    if (phraseKey)  {
        const indexKey = getMissionKeyIndexByNumber(targetProgress);
        str = str.replace(`<key=${phraseKey}>`, translate(`${phraseKey}_${indexKey}`));
    }

    return getStringWithParams(str, ...params);
}

export function getStringWithParams(str: string, ...params: string[]) {
    let result = str;
    params.forEach((param, index) => {
        result = result.replace(`<value=${index}>`, param);
    });
    return result;
}

function extractKey(str: string) {
    const start = str.indexOf('<key=');
    if (start === -1) return null;
    
    const end = str.indexOf('>', start);
    if (end === -1) return null;
    
    return str.substring(start + 5, end);
}

function getMissionKeyIndexByNumber(num: number) {
    const rules = [
      { key: 1, test: (n: number) => n === 1 },
      { key: 2, test: (n: number) => [21, 31, 41].includes(n) || (n > 20 && n % 10 === 1 && n !== 11) },
      { key: 3, test: (n: number) => n === 2 },
      { key: 4, test: (n: number) => n >= 3 && n <= 4 },
      { key: 5, test: (n: number) => (n >= 22 && n <= 24) || (n >= 32 && n <= 34) || (n % 10 >= 2 && n % 10 <= 4 && n > 20 && n !== 12 && n !== 13 && n !== 14) },
      { key: 6, test: (n: number) => n >= 5 && n <= 19 },
      { key: 7, test: (n: number) => n === 20 || (n >= 25 && n <= 30) || (n >= 35 && n <= 40) || (n > 20 && n % 10 === 0) || (n > 20 && n % 10 >= 5 && n % 10 <= 9) }
    ];
  
    const matchedRule = rules.find(rule => rule.test(num));
    
    return matchedRule ? matchedRule.key : 1;
  }

export function getRandomUniqueMissionActions(array: ActionConfig[], n: number) {
    if (n > array.length) {
        return array;
    }

    const shuffled = [...array];

    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }

    return shuffled.slice(0, n);
}